import { createReducer, on } from '@ngrx/store';
import { LearnerImportSummary } from '../models';
import { usersImporterActions } from '../actions/users-importer.actions';

export interface UsersImporterState {
    importing: boolean;
    summary: LearnerImportSummary | null;
    downloadingTemplate: boolean;
}

export const initialState: UsersImporterState = {
    importing: false,
    summary: null,
    downloadingTemplate: false,
};

export const usersImporterReducer = createReducer(
    initialState,
    on(usersImporterActions.importLearners, (state): UsersImporterState => ({
        ...state,
        importing: true,
        summary: null,
    })),
    on(usersImporterActions.importLearnersSuccess, (state, { payload }): UsersImporterState => ({
        ...state,
        importing: false,
        summary: payload,
    })),
    on(usersImporterActions.importLearnersError, (state): UsersImporterState => ({
        ...state,
        importing: false,
    })),
    on(usersImporterActions.clearSummary, (state): UsersImporterState => ({
        ...state,
        summary: null,
    })),
    on(usersImporterActions.downloadTemplate, (state): UsersImporterState => ({
        ...state,
        downloadingTemplate: true,
    })),
    on(usersImporterActions.downloadTemplateSuccess, (state): UsersImporterState => ({
        ...state,
        downloadingTemplate: false,
    })),
    on(usersImporterActions.downloadTemplateError, (state): UsersImporterState => ({
        ...state,
        downloadingTemplate: false,
    })),
    on(usersImporterActions.clear, (): UsersImporterState => ({ ...initialState })),
);
